// master-contexto.interceptor.ts
// Interceptor de SEGURANCA da Area Master.
//
// Injeta `X-Empresa-Contexto: {empresaAlvoId}` SOMENTE quando:
//   1) ha empresa alvo ativa no MasterContextoService (o suporte esta na ficha dela); E
//   2) o par (metodo, path) casa a allowlist do FRONT, que espelha a `ROTAS_CONTEXTO_MASTER` do
//      backend (`shared/contexto-rotas.ts`, com teste de paridade).
//
// A allowlist e curta de proposito: so as rotas que GERAM COBRANCA precisam de contexto, porque
// resolvem a empresa por `obterEmpresaId()` la no fundo. O resto da Area Master leva a empresa no
// path (`/master/empresas/{id}/...`) e nao passa por aqui.
//
// Registro em app.module.ts: Auth -> ContadorContexto -> MasterContexto -> HttpError.

import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MasterContextoService } from '../services/master/master-contexto.service';
import { casaAllowlist, ROTAS_CONTEXTO_MASTER } from './contexto-rotas';

/** Opt-out por chamada: deixa a request intocada mesmo com empresa alvo ativa. */
export const SEM_CONTEXTO_MASTER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class MasterContextoInterceptor implements HttpInterceptor {
  constructor(private contexto: MasterContextoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SEM_CONTEXTO_MASTER)) {
      return next.handle(req);
    }

    // Os dois interceptors escrevem o MESMO header. Se o do contador ja agiu, este nao mexe:
    // sobrescrever mandaria a requisicao para a empresa errada.
    if (req.headers.has('X-Empresa-Contexto')) {
      return next.handle(req);
    }

    const empresa = this.contexto.empresaAtual();
    // Casa por PAR (metodo, path), igual ao `casaAllowlist` do backend. As 6 rotas da Master
    // GERAM COBRANCA e entram no 400 do AP-10 como qualquer outra: enviar o header numa rota
    // fora da lista nao e mais ignorado em silencio.
    if (empresa && casaAllowlist(ROTAS_CONTEXTO_MASTER, req.method, req.url)) {
      req = req.clone({
        setHeaders: { 'X-Empresa-Contexto': String(empresa.empresaId) },
      });
    }

    return next.handle(req);
  }
}
